import {
  EXCLUSIVE_RULE_OPERATORS,
  LOWER_BOUND_RULE_OPERATORS,
  REPEATABLE_RULE_FIELDS,
  UPPER_BOUND_RULE_OPERATORS,
} from "constants/ruleEngine";
import { ConditionResult, RuleConditionRow } from "types/Models/ruleEngine";

type RuleOperator = ConditionResult["available_operators"][number];

const SINGLE_USE_OPERATOR_GROUPS = [
  LOWER_BOUND_RULE_OPERATORS,
  UPPER_BOUND_RULE_OPERATORS,
];

export const getAvailableRuleOperators = ({
  condition,
  rows,
  rowIndex,
}: {
  condition?: ConditionResult;
  rows: RuleConditionRow[];
  rowIndex: number;
}): RuleOperator[] => {
  if (!condition) return [];

  const { uuid, name, available_operators } = condition;

  if (!REPEATABLE_RULE_FIELDS.includes(name)) return available_operators;

  const otherRows = rows.filter(
    ({ field }, index) => index !== rowIndex && field === uuid
  );
  const usedOperatorTypes = otherRows.flatMap(({ conditionFunction }) =>
    available_operators
      .filter((operator) => operator.uuid === conditionFunction)
      .map(({ operator_type }) => operator_type)
  );

  if (usedOperatorTypes.some((type) => EXCLUSIVE_RULE_OPERATORS.includes(type)))
    return [];

  const usedGroups = SINGLE_USE_OPERATOR_GROUPS.filter((group) =>
    group.some((type) => usedOperatorTypes.includes(type))
  );

  return available_operators.filter(({ operator_type }) => {
    if (EXCLUSIVE_RULE_OPERATORS.includes(operator_type)) {
      return otherRows.length === 0;
    }
    return !usedGroups.some((group) => group.includes(operator_type));
  });
};
